export { InlineTableOfContents } from './InlineTableOfContents'
